import {
    Checkbox,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@mui/material';
import { ChangeEvent, useMemo } from 'react';
import { connect, useDispatch } from 'react-redux';
import { WarehouseDto } from '../../../common/PricePrgClient';
import { RootState } from '../../../store';
import { getWarehouses } from '../../stock/redux/stockSelectors';
import { updateWarehouse } from '../../stock/redux/stockSlices';

const mapStateToProps = (state: RootState) => ({
    warehouses: getWarehouses(state)
});

type Props = ReturnType<typeof mapStateToProps>;

const WarehouseSettingsTab = ({ warehouses }: Props) => {
    const warehouseArr = useMemo(() => Object.values(warehouses), [warehouses]);

    const dispatch = useDispatch();

    const handlePrimaryWarehouseChanged = (event: ChangeEvent<HTMLInputElement>, warehouse: WarehouseDto) => {
        dispatch(
            updateWarehouse.request({
                ...warehouse,
                isPrimaryWarehouse: event.target.checked
            })
        );
    };

    return (
        <Grid container>
            <Grid item>
                {warehouseArr.length === 0 ? (
                    <Typography variant="body1">No warehouses found</Typography>
                ) : (
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Shortname</TableCell>
                                    <TableCell>Primary</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {warehouseArr.map(warehouse => (
                                    <TableRow key={warehouse.warehouseId}>
                                        <TableCell component="th" scope="row">
                                            {warehouse.name}
                                        </TableCell>
                                        <TableCell>{warehouse.shortName}</TableCell>
                                        <TableCell>
                                            <Checkbox
                                                checked={warehouse.isPrimaryWarehouse}
                                                onChange={e => handlePrimaryWarehouseChanged(e, warehouse)}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Grid>
        </Grid>
    );
};

export default connect(mapStateToProps)(WarehouseSettingsTab);
